import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const StepsBox = () => {
	const block = document.querySelectorAll(".steps-box");
	if (!block) {
		return;
	}
  gsap.registerPlugin(ScrollTrigger);
  let mm = gsap.matchMedia();
	let blockOnLeave = false;

	block.forEach((el) => {
    const list = el.querySelector(".steps-box__list");
    const listWrap = el.querySelector(".steps-box__list-wrap");

    mm.add("(min-width: 768px)", () => {
			gsap.to(listWrap, {
				x: () => -listWrap.scrollWidth + listWrap.offsetWidth,
				ease: 'none',
				scrollTrigger: {
					trigger: list,
					start: 'center 50%',
					end: () => {
						if (listWrap) {
							return `+=${listWrap.scrollWidth - listWrap.offsetWidth}`
						}
					},
					pin: true,
					scrub: true,
					onLeave: () => {
						// ScrollTrigger.refresh(true);
						if (!blockOnLeave) {
							ScrollTrigger.getAll().forEach((st) => {
								if (st.trigger.className.includes('split-text-title')) {
									st.kill();
								}
							});
							document.dispatchEvent(new Event("split-text-title-refresh"));
							blockOnLeave = true;
						}
					},
				}
			});
		});
	});
};

export default StepsBox;
